// extracted by mini-css-extract-plugin
module.exports = {"emptyTableRoot":"TFC8BIOz","notEmpty":"vOe1quZ_","emptyTable":"PWDskhVZ","emptyCell":"FhauXFtu","stickyContent":"SLdk4lvf","absoluteContent":"K_RuSQOa"};